export default __webpack_public_path__ + "static/media/v-44.ca9d606e.svg";